// Общение с бэкендом. Токен живёт в памяти вкладки: мини-апп открывается заново
// при каждом запуске, а хранить подписанные данные в localStorage незачем.
let token: string | null = null

export function setToken(value: string | null): void {
  token = value
}

export interface CallOptions {
  method?: 'GET' | 'POST'
  body?: unknown
  form?: FormData
}

/**
 * Достаёт человеческую причину ошибки из тела ответа FastAPI.
 *
 * Вынесена отдельной чистой функцией: `detail` может быть строкой (наш
 * случай) или структурой валидации Pydantic — на непонятной форме тихо
 * откатываемся на код ответа, а не падаем ещё раз внутри обработки ошибки.
 */
export function pickErrorDetail(body: unknown, fallback: string): string {
  if (body && typeof body === 'object' && 'detail' in body) {
    const detail = (body as { detail?: unknown }).detail
    if (typeof detail === 'string' && detail.length > 0) return detail
  }
  return fallback
}

export async function call<T>(path: string, options: CallOptions = {}): Promise<T> {
  const { method = 'GET', body, form } = options
  const headers: Record<string, string> = {}
  if (token) headers.Authorization = `Bearer ${token}`
  if (body) headers['Content-Type'] = 'application/json'

  const res = await fetch(`/api${path}`, {
    method,
    headers,
    body: form || (body ? JSON.stringify(body) : undefined),
  })

  if (!res.ok) {
    const fallback = `Ошибка ${res.status}`
    let detail = fallback
    try {
      detail = pickErrorDetail(await res.json(), fallback)
    } catch {
      /* тело не json — оставляем код */
    }
    throw new Error(detail)
  }

  return res.status === 204 ? (null as T) : ((await res.json()) as T)
}
